import React, { Component } from 'react';
import {dateHelper, constant, api } from "../helpers";
import { UploadPanel, UploadDisplay } from "../components";
import './Site.css';
import 'react-datepicker/dist/react-datepicker.css';
import Alert from "react-s-alert";

export default class ShippingUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: null,
      messageColor: null,
      isMessageVisible: false,
      importProcessing: false,
      uploadResults: null,
      searchDate: dateHelper.setDefaultShippingDate(),
      searchSku: '',
      searchMonthTotal: null,
      filters: [],
      pagedList: null,
      sortColumn: "DateOccurred",
      sortAscending: true,
      editMode: true,
      showUploadPanel: false,
      jobId: null
    }
    this.checkJobStatus = this.checkJobStatus.bind(this);
  }

  componentDidMount(){
    let jobId = localStorage.getItem("UploadJobId") || null;
    this.setState({
      jobId: jobId
    }, ()=>{
      // console.log(this.state.jobId, " STATE job id");
      this.checkJobStatus();
    });
  }

  checkJobStatus(){
    if (!this.state.jobId) return;
    // console.log("CHECK JOB STATS -JOB ID: ", this.state.jobId)
    api.post("Upload/CheckJobProgress/" + Number(this.state.jobId))
    .then(res => {
      if(res && res.data){
        switch (res.data)
        {
            case "Succeeded":
                localStorage.removeItem("UploadJobId");
                return Alert.success("Import Completed.");
            case "Enqueued":
            case "Processing":        
            default:
              return Alert.warning("Import is being processed...");
        }
      }
    }).catch(error => console.log(`There was an error checking job status for JobId: ${this.state.jobId}. Error: ${error}`));
  }


  render() {
    return (
      <div>
        {this.state.showUploadPanel && (
          <UploadPanel
            uploadType={constant.uploadType.shipping}
            onCancel={() => this.setState({ showUploadPanel: false })}
            onSuccess={this.onSearchDateChange}
          />
        )}
        <UploadDisplay
          uploadType={constant.uploadType.shipping}
          saveApiRoute={"Product/SaveProductShippingCount"}
          apiRoute={"Product/GetSalesSummary"}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ShippingUpload.js